// 滚动至需要填写项Api
// 已全局混入
// 使用方法：
// 1. 在需要滚动元素添加name属性
// 2. 在需要滚动的地方调用this.scrollTo(name)

let scrollToApi = {
  data() {
    return {};
  },
  methods: {
    scrollTo(name) {
      if (!name) {
        console.error("name不能为空-->");
        return;
      }
      let target = document.getElementsByName(name)[0];
      if(!target) return;
      target.scrollIntoView({ behavior: "smooth", block: "center" });
      target.classList.add("shaking");
      setTimeout(() => {
        target.classList.remove("shaking");
      }, 500);
    }
  }
};
export default scrollToApi;



// WEBPACK FOOTER //
// ./src/utils/scrollToApi.js